import { images } from 'app/design/images';
import { PCImage } from 'app/design/primitives/image';
import { env } from 'app/lib/env';
import { isAnyWhiteLabel } from 'app/utils/helpers';
import { useTheme } from 'app/shopify';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

type PartagePlusBadgePlan = 'free' | 'premium';
type PartagePlusBadgeVariant = 'default' | 'small';

const dimensionsByVariant = {
  default: {
    imageHeight: 16,
    imageWidth: 68,
    paddingBottom: 4,
    paddingHorizontal: 8,
    paddingTop: 4,
  },
  small: {
    imageHeight: 12.6667,
    imageWidth: 53.8333,
    paddingBottom: 3.1667,
    paddingHorizontal: 6.3333,
    paddingTop: 3.1667,
  },
} satisfies Record<PartagePlusBadgeVariant, Record<string, number>>;

export function PartagePlusBadge({
  plan = 'premium',
  variant = 'default',
}: {
  plan?: PartagePlusBadgePlan;
  variant?: PartagePlusBadgeVariant;
}) {
  const { t } = useTranslation('my-plan');
  const theme = useTheme();
  const dimensions = dimensionsByVariant[variant];

  if (isAnyWhiteLabel()) return null;

  if (plan === 'free') {
    return (
      <View
        style={{
          alignItems: 'center',
          backgroundColor: theme.colors['surface.info.subtle'],
          borderRadius: theme.borderRadii['radius.full'],
          justifyContent: 'center',
          paddingHorizontal: theme.spacing['spacing.general.x2'],
          paddingVertical: theme.spacing[variant === 'small' ? 'spacing.general.x0,5' : 'spacing.general.x1'],
        }}
      >
        <Text color="text.primary" fontSize={variant === 'small' ? 12 : 14} fontWeight="500" lineHeight={16}>
          {t('design.discovery')}
        </Text>
      </View>
    );
  }

  return (
    <View
      style={{
        backgroundColor: theme.colors['surface.brand.secondary-5.default'],
        borderRadius: theme.borderRadii['radius.sm'],
        paddingBottom: dimensions.paddingBottom,
        paddingHorizontal: dimensions.paddingHorizontal,
        paddingTop: dimensions.paddingTop,
        width: dimensions.imageWidth + dimensions.paddingHorizontal * 2,
      }}
    >
      <PCImage
        source={env.IS_PARTAKE ? images.partakePlusBadge : images.partagePlusBadge}
        style={{ height: dimensions.imageHeight, width: dimensions.imageWidth }}
      />
    </View>
  );
}
